import { getToken } from '../../components/authentication/functions/authentication_management';
import axios from 'axios';
import { getSimulationApiBaseUrl } from '../getAtlasApiBaseUrl';

const API_BASE_URL = getSimulationApiBaseUrl();

// Debug function to test API connectivity and authentication
export async function debugApiConnection(): Promise<void> {
  console.log('🔍 API Connection Debug');
  console.log('📊 API Base URL:', API_BASE_URL);
  
  // Check authentication
  const tokenObj = getToken();
  if (!tokenObj) {
    console.error('❌ No authentication token found');
    console.log('💡 Please log in to Atlas first');
    return;
  }
  
  console.log('✅ Token found:', {
    type: tokenObj.token_type,
    length: tokenObj.access_token?.length || 0,
    preview: tokenObj.access_token?.substring(0, 20) + '...'
  });
  
  // Test basic API connectivity
  try {
    console.log('🔍 Testing basic API connectivity...');
    const response = await axios.get(`${API_BASE_URL}/auth/auth_test`, {
      headers: {
        'Authorization': `Bearer ${tokenObj.access_token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('✅ API connectivity test successful:', response.data);
    return;
  } catch (error: any) {
    console.error('❌ API connectivity test failed:', error.message);
    if (error.response) {
      console.error('📊 Error status:', error.response.status);
      console.error('📊 Error data:', error.response.data);
    }
  }
}

// Test ride upload with minimal data
export async function debugRideUpload(): Promise<void> {
  console.log('🔍 Testing ride upload...');
  
  const tokenObj = getToken();
  if (!tokenObj) {
    console.error('❌ No authentication token found');
    return;
  }
  
  const testRides = [{
    external_reference_id: 'debug-ride-1',
    external_user_reference_id: 'debug-user-1',
    from_latitude: 51.5074,
    from_longitude: -0.1278,
    to_latitude: 51.5155,
    to_longitude: -0.1426,
    from_address: 'London Bridge',
    to_address: 'Tower Bridge',
    request_type: 'departure_fixed',
    passengers: [{ number_of_passengers: 1, type: 'standard' }],
    request_time: '2024-01-15T08:00:00.000',
    batch_id: 'debug-batch-' + Date.now()
  }];
  
  try {
    const response = await axios.post(
      `${API_BASE_URL}/data_generator/import_rides/debug-test-rides`,
      testRides,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenObj.access_token}`,
        },
      }
    );
    
    console.log('✅ Ride upload test successful:', response.data);
  } catch (error: any) {
    console.error('❌ Ride upload test failed:', error.message);
    if (error.response) {
      console.error('📊 Error status:', error.response.status);
      console.error('📊 Error data:', error.response.data);
    }
  }
}

// Make debug functions available in browser console
if (typeof window !== 'undefined') {
  (window as any).debugApiConnection = debugApiConnection;
  (window as any).debugRideUpload = debugRideUpload;
}

// Debug logging (only in development, commented out to reduce console noise)
// if (process.env.NODE_ENV === 'development') {
//   console.log('🔧 Debug functions available:');
//   console.log('  - debugApiConnection() - Test API connectivity and auth');
//   console.log('  - debugRideUpload() - Test ride upload functionality');
// }
